<template>
    <div class="wrapper">
        <NavBar />
        <!-- Spinner Start -->
        <div id="spinner" v-if="halamanloading"
            class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
            style="opacity: 0.5;">
            <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <!-- Spinner End -->
        <div class="container-fluid py-2" style="background-color: white !important;">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-12 text-center wow fadeInDown">
                            <img :src="folder" alt="User Profil" class="img-size-50 mr-3 img-circle shake-element"
                                style="height: 80px !important;width: 80px !important;"><br><br>
                            <h5>Halo {{ sapaan }}, <span class="text-success">{{ namauser }}</span>, {{
                                jabatanuser }}
                            </h5>
                            <div class="row">
                                <div class="col-sm-2 text-center"></div>
                                <div class="col-sm-8 text-center">
                                    <div class="card" style="background-color: rgba(255, 255, 255, 0.1)">
                                        <div class="row py-2 px-2">

                                            <div class="col-sm-12 text-center" style="padding-bottom: 5px;">
                                                {{ hasil }} {{ hariAngka }}
                                            </div>
                                            <div class="col-sm-12 text-center" style="min-height: 500px !important;">
                                                <div id="spinner"
                                                    v-if="latitude == '' || latitude == null || latitude == undefined || latitude == '0'"
                                                    class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
                                                    style="opacity: 0.6;position:absolute !important;">
                                                    <div class="spinner-border text-danger"
                                                        style="width: 3rem; height: 3rem;" role="status">
                                                        <span class="sr-only text-warning">Loading...</span>
                                                    </div>
                                                </div>
                                                <iframe :src="sourcenya" class="col-sm-12 text-center"
                                                    style="min-height: 500px !important;" frameborder="0" id="maps"
                                                    scrolling="no" @load="loadpeta()"
                                                    v-if="latitude != '' && latitude != null && latitude != undefined && latitude != '0'">
                                                </iframe>
                                            </div>
                                            <div class="col-sm-12 text-center" style="padding-bottom: 5px;">
                                                <div class="row">
                                                    <div class="col-sm-3 text-center">&nbsp;</div>
                                                    <div class="col-sm-3 text-center">
                                                        <div class="input-group mb-3">
                                                            <div class="input-group-prepend">
                                                                <span class="input-group-text"><i
                                                                        class="fab fa-creative-commons-share"></i></span>
                                                            </div>
                                                            <input type="date" class="form-control form-control-sm"
                                                                id="tanggal" name="tanggal" placeholder="Tanggal Absen"
                                                                v-model="tanggal">
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-3 text-center">
                                                        <button type="button"
                                                            class="btn btn-primary btn-sm text-white lebar2"
                                                            @click="prosesdata()" data-toggle="tooltip"
                                                            data-placement="left" title="Lihat data..">
                                                            <i class="fas fa-search"></i> Lihat Lokasi Absensi
                                                        </button>
                                                    </div>
                                                    <div class="col-sm-3 text-center">&nbsp;</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-2 text-center"></div>
                            </div>
                        </div><!-- /.col -->
                        <div class="col-sm-12 text-center">&nbsp;</div>
                        <div class="col-sm-12 text-center">&nbsp;</div>
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->
        </div>
        <Footer />
    </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import vSelect from 'vue-select';
import Footer from "../componen/FooterAksi.vue";
import NavBar from "../componen/NavBarAksi.vue";
import Menu from "../componen/Menu.vue";
import swal from 'sweetalert2';
import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };

export default {
    components: {
        Footer, NavBar, Menu, vSelect, apexchart: VueApexCharts,
    },
    data() {
        return {
            halamanloading: true,
            showFilter: true,
            iduser: JSON.parse(localStorage.getItem("isistemaksi")),
            leveluser: JSON.parse(localStorage.getItem("lsistemaksi")),
            namauser: JSON.parse(localStorage.getItem("namasistemaksi")),
            jabatanuser: JSON.parse(localStorage.getItem("jabatansistemaksi")),
            tokensistemaksi: JSON.parse(localStorage.getItem("tokensistemaksi")),
            datapesan: '',
            sapaan: '',
            datamaster: [],
            carikata: '',
            datatahun: [],
            tahun: [],
            defaultSelectedtahun: {},
            selectedtahun: new Date().getFullYear(),
            jam: '',
            menit: '',
            detik: '',
            hasil: '',
            hariAngka: '',
            statusjam: '',
            timer: null,
            folder: process.env.VUE_APP_URL_API + 'androidAbsensi-Gambar?f=' + JSON.parse(localStorage.getItem("ikonsistemaksi")),
            latitude: '',
            longitude: '',
            project_id: process.env.VUE_APP_PROJECT_ID,
            jam_masuk: '',
            jam_pulang: '',
            tanggal_masuk: '',
            tanggal_pulang: '',
            tipe: '',
            id: '',
            ket: '',
            class: '',
            proses: '',
            durasi: '',
            jamdurasi: 0,
            menitdurasi: 0,
            detikdurasi: 0,
            linknya: process.env.VUE_APP_URL_API,
            tanggal: '',
        }
    },
    methods: {
        LihatWaktu() {
            this.timer = setInterval(() => {
                var jam = new Date().getHours();
                if (jam < 12) {
                    this.sapaan = "Selamat Pagi";
                } else if (jam < 15) {
                    this.sapaan = "Selamat Siang";
                } else if (jam < 19) {
                    this.sapaan = "Selamat Sore";
                } else {
                    this.sapaan = "Selamat Malam";
                }

                var now = new Date();

                this.jam = now.getHours();
                this.menit = now.getMinutes();
                this.detik = now.getSeconds();
                this.jam = (this.jam < 10) ? "0" + this.jam : this.jam;
                this.menit = (this.menit < 10) ? "0" + this.menit : this.menit;
                this.detik = (this.detik < 10) ? "0" + this.detik : this.detik;

                this.hariAngka = 'Jam: ' + this.jam + ':' + this.menit + ':' + this.detik; // 0 (Minggu) - 6 (Sabtu) [10]
                //this.durasi = this.jamdurasi + ':' + this.menitdurasi + ':' + this.detikdurasi; // 0 (Minggu) - 6 (Sabtu) [10]
                var tanggal = now.getDate(); // 1 - 31 [2]
                var bulan = now.getMonth(); // 0 - 11 [2]
                var tahun = now.getFullYear(); // 4 digit tahun [2]

                // Array nama hari dan bulan (opsional, untuk hasil dalam Bahasa Indonesia)
                var namaHari = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];
                var namaBulan = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];

                // Format: "Selasa, 3 Februari 2026"
                this.hasil = namaHari[now.getDay()] + ", " + tanggal + " " + namaBulan[bulan] + " " + tahun;

            }, 1000);
        },
        GPSBrowser() {
            if (navigator.geolocation) {
                const successCallback = (position) => {
                    this.latitude = position.coords.latitude;
                    this.longitude = position.coords.longitude;
                };
                const errorCallback = (error) => {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Mohon Aktifkan GPS / Lokasi Gadget / Permission Location..',
                    });
                    return false;
                };

                navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
            }
            else {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Aktifkan GPS / Lokasi Gadget / Permission Location..',
                });
                return false;
            }
        },
        prosesdata() {
            this.loadpetaabsen();
        },
        keluar() {
            swal.fire({
                title: "Konfirmasi",
                text: "Yakin Hendak Keluar Aplikasi?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Batal",
                confirmButtonColor: "#3a4767",
                cancelButtonColor: "#ffaa05",
                confirmButtonText: "Keluar"
            }).then((result) => {
                if (result.isConfirmed) {
                    this.ClearlocalStorageAksi();
                }
            });

            return false;
        },
        loadpetaabsen() {
            this.halamanloading = true;
            //alert(this.selectedfilter);
            var messagetemp = '';
            messagetemp = this.linknya + "|" + this.tanggal + "|" + this.iduser + "|" + this.project_id + "|" + this.tokensistemaksi;
            const message = messagetemp;
            const iframe = document.getElementById("maps");
            this.sourcenya = '';
            this.sourcenya = '/lokasiku.html';
            iframe.contentWindow.postMessage(message, "*");
            this.halamanloading = false;
        },
        loadpeta() {
            this.halamanloading = true;
            //alert(this.selectedfilter);
            var messagetemp = '';
            messagetemp = this.linknya + "||" + this.iduser + "|" + this.project_id + "|" + this.tokensistemaksi;
            const message = messagetemp;
            const iframe = document.getElementById("maps");
            this.sourcenya = '';
            this.sourcenya = '/lokasiku.html';
            iframe.contentWindow.postMessage(message, "*");
            this.halamanloading = false;
        },
    },
    mounted() {
        this.LihatWaktu();
        this.GPSBrowser();
        var bulan = new Date().getMonth() + 1;
        bulan = (bulan < 10) ? "0" + bulan : bulan;
        this.tanggal = new Date().getFullYear() + '-' + bulan + '-' + new Date().getDate();
        this.halamanloading = false;
    }
}
</script>
<style></style>